import PropTypes from 'prop-types';
import BillingItemAmountType from './billingItemAmountType';

const BillingItemType = PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.string,
  billing_account_id: PropTypes.string,
  billing_account: PropTypes.object,
  billing_date: PropTypes.string,
  billing_installment_id: PropTypes.string,
  billing_item_amounts: PropTypes.arrayOf(BillingItemAmountType),
  description: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  balance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  order_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  payment_method_display_name: PropTypes.string,
  checklist_answer_id: PropTypes.string,
  errors: PropTypes.object
});

export default BillingItemType;
